/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaGlobe, FaBars, FaTimes } from "react-icons/fa";
import logoArabic from "../../../assets/logoArabic.png";
import logoEnglish from "../../../assets/logoEnglish.png";
import { NAV_LINKS } from "./landing.data";

export default function LandingNav({ isArabic }) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleLang = () => {
    const next = isArabic ? "en" : "ar";
    i18n.changeLanguage(next);
    localStorage.setItem("lang", next);
    document.documentElement.dir = next === "ar" ? "rtl" : "ltr";
    document.body.dir = next === "ar" ? "rtl" : "ltr";
  };

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const signInLabel =
    typeof t("login.signIn") === "string" && t("login.signIn") !== "login.signIn"
      ? t("login.signIn")
      : isArabic
        ? "تسجيل الدخول"
        : "Sign In";

  return (
    <header className={`gl-nav${scrolled ? " gl-nav--scrolled" : ""}`}>
      <div className="gl-shell gl-nav__inner">
        <a href="/" aria-label="Madar">
          <img
            className="gl-nav__logo"
            src={isArabic ? logoArabic : logoEnglish}
            alt="مدار المجرة"
          />
        </a>

        <nav className="gl-nav__links" aria-label="Main">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              type="button"
              className="gl-nav__link"
              onClick={() => go(link.id)}
            >
              {isArabic ? link.labelAr : link.labelEn}
            </button>
          ))}
        </nav>

        <div className="gl-nav__actions">
          <button type="button" className="gl-btn gl-btn--lang" onClick={toggleLang}>
            <FaGlobe size={14} style={{ marginInlineEnd: 6 }} />
            {isArabic ? "EN" : "AR"}
          </button>

          <button
            type="button"
            className="gl-btn gl-btn--outline gl-btn--sm d-none d-md-inline-flex"
            onClick={() => navigate("/login")}
          >
            {signInLabel}
          </button>

          <button
            type="button"
            className="gl-btn gl-btn--gold gl-btn--sm d-none d-md-inline-flex"
            onClick={() => navigate("/signup")}
          >
            {isArabic ? "ابدأ الآن" : "Get Started"}
          </button>

          <button
            type="button"
            className="gl-nav__menu-btn"
            aria-label="Menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <FaTimes size={18} /> : <FaBars size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="gl-shell gl-nav__drawer">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              type="button"
              className="gl-nav__link"
              style={{ textAlign: "start", width: "100%" }}
              onClick={() => go(link.id)}
            >
              {isArabic ? link.labelAr : link.labelEn}
            </button>
          ))}
          <button
            type="button"
            className="gl-btn gl-btn--outline"
            onClick={() => {
              setOpen(false);
              navigate("/login");
            }}
          >
            {signInLabel}
          </button>
          <button
            type="button"
            className="gl-btn gl-btn--gold"
            onClick={() => {
              setOpen(false);
              navigate("/signup");
            }}
          >
            {isArabic ? "ابدأ الآن" : "Get Started"}
          </button>
        </div>
      )}
    </header>
  );
}
